import Map from './map.js';
import $ from "jquery";

$(document).ready(function () {
    // set the js_check value, to prevent robot submits
    $('input[name=js_check]').val('wielinkwebsolutions');

    General.init();
    Search.init();
    Products.init();
});

var General = {
    zipcode_request: null,

    init: function () {
        // $('[required]').removeAttr('required');
        // make sure the first required field is in view and not behind the fixed header
        $("form input, form select, form textarea").on("invalid", function () {
            General.handleInvalidFromBrowser($(this));
        });

        $(document).on('submit', '.ajax-form', function (e) {
            e.preventDefault();
            General.handleAjaxForm($(this));
        });
        $(document).on('change', 'input[name="type_rouwbericht"]', function (e) {
            e.preventDefault();
            if (jQuery(this).val() == 'Rouwbericht') {
                jQuery('fieldset[for="plaatsen_bij_hoofdadv"]').show();
            } else {
                jQuery('fieldset[for="plaatsen_bij_hoofdadv"] input:checked').prop('checked', false)
                jQuery('fieldset[for="plaatsen_bij_hoofdadv"] input:checked').attr('checked', false)
                jQuery('fieldset[for="plaatsen_bij_hoofdadv"]').hide();
            }

            if (jQuery(this).val() == 'Dankbetuiging') {
                jQuery('label[for="relation_to_deceased"] option:selected').removeAttr('selected')
                jQuery('label[for="relation_to_deceased"] option:selected').prop('selected', false)
                jQuery('label[for="relation_to_deceased"]').hide();
            } else {
                jQuery('label[for="relation_to_deceased"]').show();
            }
        });
        jQuery('input[name="type_rouwbericht"]:checked').trigger('change');
        $(document).on('change', '.address-fill-trigger', function () {
            General.getAddressForZipcode($(this));
        });

        $(document).on('change', 'input[type="file"]', function () {
            if ($(this).val() !== '') {
                $(this).parents('label').addClass('is-filled');
            } else {
                $(this).parents('label').removeClass('is-filled');
            }

            General.doProspectDummyText();
        });

        $(document).on('click', '.clear-file-trigger', function (e) {
            e.stopPropagation();
            e.preventDefault();

            var $label = $(this).parents('label');
            $label.removeClass('is-filled');

            var $input = $label.find('input');
            $input.val('');

            General.doProspectDummyText();
        });

        $(document).on('click', '.chat-trigger', function () {
            console.log('chat trigger clicked');
            $('#fc_frame').show();
            window.fcWidget.open();
        });

        // remove the aggressive red border when the user is busy with a form element
        $(document).on('click', 'fieldset.in-error', function () {
            $(this).removeClass('in-error');
        });
        $(document).on('focus', 'label.in-error', function () {
            $(this).removeClass('in-error');
        });

        $(document).on('focus', 'input, textarea, select', function () {
            // $(this)[0].scrollIntoView({behavior: 'smooth'});
        });

        if ($('.fixed-footer-buttons').length > 0) {
            $('body').addClass('has-fixed-footer');
        }

        var $allVideos = $(".cms-content iframe"),

            // The element that is fluid width
            $fluidEl = $(".cms-content");

        // Figure out and save aspect ratio for each video
        $allVideos.each(function () {
            $(this)
                .data('aspectRatio', this.height / this.width)

                // and remove the hard coded width/height
                .removeAttr('height')
                .removeAttr('width');
        });

        // When the window is resized
        $(window).resize(function () {
            var newWidth = $fluidEl.width();

            // Resize all videos according to their own aspect ratio
            $allVideos.each(function () {

                var $el = $(this);
                $el
                    .width(newWidth)
                    .height(newWidth * $el.data('aspectRatio'));
            });

            // Kick off one resize to fix all videos on page load
        }).resize();
    },

    doProspectDummyText: function () {
        if ($('section.prospect').length > 0) {
            var $content = $('#content');
            var filled = 0;
            var dummyText = 'Zie bijlage';
            if ($content.val() === '' || $content.val() === dummyText) {
                if ($('.is-filled').length > 0) {
                    $content.val(dummyText);
                } else if ($content.val() == dummyText) {
                    $content.val('');
                }
            }
        }
    },

    getAddressForZipcode: function ($that) {
        var $parent = $that.parents('.address-fields-container');
        var zipcode = $parent.find('.zipcode input').val();
        var street_number = $parent.find('.street-number input').val();

        if (General.zipcode_request) {
            General.zipcode_request.abort();
        }

        if (zipcode !== '' && street_number !== '') {
            General.zipcode_request = $.post(
                '/ajax/address-for-zipcode',
                {
                    zipcode: zipcode,
                    street_number: street_number
                },
                function (data) {
                    if (data.success) {
                        $parent.find('.street input').val(data.address.street).parents('label.in-error').removeClass('in-error');
                        $parent.find('.street_number input').val(data.address.house_number).parents('label.in-error').removeClass('in-error');
                        $parent.find('.city input').val(data.address.city).parents('label.in-error').removeClass('in-error');
                    }
                },
                'json'
            )
        }
    },

    handleInvalidFromBrowser: function ($input) {
        if ($input.attr('type') === 'radio') {
            $input.parents('fieldset').addClass('in-error');
        } else {
            $input.parents('label').addClass('in-error');
        }

        var $form = $input.parents('form');
        var $first_invalid = $form.find('.in-error').first();

        if($first_invalid.length < 1) {
            return;
        }

        $('html, body').animate({
            scrollTop: $first_invalid.offset().top - ($('header').outerHeight() + 40)
        }, 0);
    },

    handleAjaxForm: function ($form) {
        $('input[name=js_check]').val('wielinkwebsolutions');

        // do not post the form before we got a response from the server
        if ($form.hasClass('sending')) {
            return;
        }

        // values to be used for posting
        var $submit_button = $form.find('button[type="submit"]');
        var form_data = new FormData($form[0]);
        var form_action = $form.attr('action');

        // make sure the submit button will keep it's dimensions when sending
        $submit_button.outerWidth($submit_button.outerWidth());
        $submit_button.outerHeight($submit_button.outerHeight());

        // tag this form as sending
        $form.addClass('sending');

        // reset the form elements previously in error
        $form.find('.in-error').removeClass('in-error');
        $form.find('.error-message').slideUp('fast', function () {
            $(this).remove();
        });

        // do the post to the server
        $.ajax({
            method: 'POST',
            url: form_action,
            data: form_data,
            processData: false,
            contentType: false,
            cache: false,
            dataType: 'JSON',
            success: function (response) {
                // we got a response, so we are no longer sending
                $form.removeClass('sending');

                if (response.result === 'error') {
                    General.handleErrors($form, response);
                } else if (response.result === 'success') {
                    if (response.href !== undefined && response.href !== '') {
                        // we got a new URL to move to, let's redirect the user
                        location.href = response.href;
                    } else if (response.html !== undefined) {
                        // we got response html, so we can replace the form with new content
                        var $replacementContainer = $form.parents('.ajax-form--replacement-container');
                        if ($replacementContainer.length === 0) {
                            $replacementContainer = $form;
                        }

                        // check if we are inside a modal
                        var inModal = false;
                        if ($form.parents('.modal-container').length > 0) {
                            inModal = true;
                        }

                        $replacementContainer.replaceWith(response.html);

                        var $formSubmitted = $('.form-submitted');
                        if ($formSubmitted.length > 0) {
                            if (!inModal) {
                                $('html, body').animate({
                                    scrollTop: $formSubmitted.offset().top - ($('header').outerHeight() + 120)
                                }, 500);
                            } else {
                                $(window).resize();
                            }
                        }
                    }
                }
            },
            error: function (xhr) {
                $form.removeClass('sending');

                if (xhr.status === 422) {
                    General.handleErrors($form, $.parseJSON(xhr.responseText));
                } else {
                    Modal.customAlert('Er ging iets fout', 'Er is een fout opgetreden tijdens het verwerken van uw verzoek. De status code is: ' + xhr.status);
                }
            }
        });
    },

    handleErrors: function ($form, response) {
        // set every form element and/or fieldset in error
        $.each(response.errors, function (id, message) {
            // make sure we can handle laravel array notation for our ids
            id = id.replace('.', '_');
            if ($form.data('id-prefix') !== '' && $form.data('id-prefix') !== undefined) {
                id = $form.data('id-prefix') + id;
            }

            $form.find('label[for="' + id + '"]').addClass('in-error').find('input, textarea, .styled-select').before('<div class="error-message">' + message + '</div>');
            $form.find('fieldset[for="' + id + '"]').addClass('in-error').find('legend').after('<div class="error-message">' + message + '</div>');
        });

        if ($('.g-recaptcha').length > 0) {
            grecaptcha.reset();
        }

        // make the error messages visible
        $('.error-message').slideDown('fast', function () {
            // call the resize of window, and let the modal.js determine if the modal still fits the window
            $(window).resize();
        });

        // scroll to the first form element in error, so the user does not miss the error message
        $form.find('.in-error')[0].scrollIntoView({behavior: 'smooth'});
    },

    setButtonLoading: function ($button) {
        // make sure the submit button will keep it's dimensions when sending
        if ($button.outerWidth() > 0) {
            $button
                .outerWidth($button.outerWidth())
                .outerHeight($button.outerHeight());
        }
        $button.find('.submit-loading-indicator').show();

        $button.find('span').hide();
    },

    unsetButtonLoading: function ($button) {
        $button
            .outerWidth('auto')
            .outerHeight('auto')
            .find('.submit-loading-indicator').hide();
        $button.find('span').show();
    },

    indicatePricesLoading: function () {
        $('.newspaper-properties .price-loading-indicator').css('display', 'inline-block');
        $('.newspaper-properties .newspaper-properties--content').hide();
    },

    indicatePricesLoaded: function () {
        $('.newspaper-properties .price-loading-indicator').hide();
        $('.newspaper-properties .newspaper-properties--content').css({display: 'inline'});
    },
};

window.General = General;

// object that handels the search-bar component
var Search = {
    hint_request: null,
    hint_timer: null,

    init: function () {
        // hint search results when the user is typing
        $(document).on('keyup', '.search-input', function (e) {
            // prevent function keys from doing unneeded server requests - https://www.cambiaresearch.com/articles/15/javascript-char-codes-key-codes
            var functionKeys = [9, 16, 17, 18, 19, 20, 27, 32, 33, 34, 35, 36, 37, 38, 39, 40, 45, 91, 92, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 144, 145];
            if ($.inArray(e.keyCode, functionKeys) > -1) {
                return;
            }

            var $parent = $(this).parent();

            // handle the enter key as a submit instead of a hint request
            if (e.keyCode === 13) {
                e.preventDefault();

                Search.find($parent, $(this).val());
            } else {
                Search.hint($parent, $(this), ($(this).parents('.navigation-search-container').length > 0));
            }
        });

        // take the clicked suggestion and put it into the search form and submit the form
        $(document).on('click', '.search-hints li a', function (e) {
            if ($(this).parents('.navigation-search-container').length === 0) {
                e.preventDefault();

                var $label = $(this).closest('label');
                var search_for = $(this).parent().data('rel');
                Search.find($label, $(this).parent().data('rel'), $(this).parent().data('search-type'));
            }
        });

        // search for the entered query when the user clicks the search button
        $(document).on('click', '.search-bar--fields-container button', function (e) {
            e.preventDefault();

            var $label = $(this).prev();
            var search_for = $label.find('[name="keyword"]').val();
            Search.find($label, search_for);
        });

        $(document).on('click', '.search-results--load-more', function (e) {
            $(this)
                .fadeOut()
                .parent()
                .find('li.hidden')
                .fadeIn();
        });

        // reset the search, clear any selected papers
        $(document).on('click', '.button--reset-search', function (e) {
            e.preventDefault();

            Search.reset($(this));
        });

        // on mobile you can close the suggestions without making a selection
        $(document).on('click', '.search-hints--close-trigger', function () {
            $(this).parents('.search-hints').slideUp();
        });
    },

    hint: function ($parent, $that, in_navigation) {
        if (Search.hint_timer) {
            clearTimeout(Search.hint_timer);
        }

        Search.hint_timer = setTimeout(function () {
            Search.doHint($parent, $that, in_navigation);
        }, 200);
    },

    doHint: function ($parent, $that, in_navigation) {
        // this class is to make sure the double border is present, needed for the hint container styling purposes
        $that.addClass('force-focus');

        // remove any error messages present
        Search.clearErrorMessage($parent);

        // are we already searching? if so, abort that previous request, as this can give timing issues with responses
        if (Search.hint_request) {
            Search.hint_request.abort();
        }

        // no input provided? remove the hints
        if ($that.val() === '') {
            $parent.find('.search-hints').slideUp();

            return;
        }

        Search.hint_request = $.post(
            '/ajax/get-hints',
            {
                keyword: $that.val(),
                in_navigation: in_navigation
            },
            function (data) {
                var pages_found = false;
                var $pages_container = $parent.find('.search-hints--pages-container');
                var $pages_container_list = $pages_container.find('ul');
                var towns_found = false;
                var $towns_container = $parent.find('.search-hints--towns-container');
                var $towns_container_list = $towns_container.find('ul');
                var newspapers_found = false;
                var $newspapers_container = $parent.find('.search-hints--newspapers-container');
                var $newspapers_container_list = $newspapers_container.find('ul');

                // handle pages, if returned
                if (data.pages !== undefined && data.pages.length > 0) {
                    // clear previous results
                    $pages_container_list.empty();

                    // make the container visible
                    $pages_container.show();

                    // flag that we did find pages
                    pages_found = true;

                    // create a list item for each returned town
                    jQuery(data.pages).each(function (index, item) {
                        var link_label = item['link_label'];
                        var url = item['url'];

                        $pages_container_list.append('<li data-search-type="page" data-rel="' + link_label + '"><a href="' + url + '">' + link_label + '</a></li>');
                    });
                } else {
                    $pages_container.hide();
                }

                // handle towns, if returned
                if (data.towns !== undefined && data.towns.length > 0) {
                    // clear previous results
                    $towns_container_list.empty();

                    // make the container visible
                    $towns_container.show();

                    // flag that we did find towns
                    towns_found = true;

                    // create a list item for each returned town
                    jQuery(data.towns).each(function (index, item) {
                        var town = item['town'];
                        var province = item['province'];
                        var name = town + ' (' + province + ')';
                        var url = item['url'];

                        $towns_container_list.append('<li data-search-type="town" data-rel="' + name + '"><a href="' + url + '">' + town + ' <small>(' + province + ')</small></a></li>');
                    });
                } else {
                    $towns_container.hide();
                }

                // handle papers, if returned, logic almost the same
                if (data.papers !== undefined && data.papers.length > 0) {
                    $newspapers_container_list.empty();
                    $newspapers_container.show();
                    newspapers_found = true;

                    jQuery(data.papers).each(function (index, item) {
                        var name = item['name'];
                        var url = item['url'];

                        $newspapers_container_list.append('<li data-search-type="newspaper" data-rel="' + name + '"><a href="' + url + '">' + name + '</a></li>');
                    });
                } else {
                    $newspapers_container.hide();
                }

                // check if any results are returned, thus if we have to show the hints or not
                if (pages_found || towns_found || newspapers_found) {
                    $parent.find('.search-hints').slideDown();
                } else {
                    $parent.find('.search-hints').slideUp();
                }
            },
            'json'
        )
    },

    reset: function ($that) {
        General.setButtonLoading($that);

        $.get(
            '/ajax/reset-selection',
            function (data) {
                if (data.result === 'ok') {
                    Search.handleResetSwitch();
                }
            },
            'json'
        )
    },

    handleResetSwitch: function () {
        var $previousSelection = $('.search-results--type-previous-selection');
        var $searchBarContainer = $previousSelection.siblings('.search-bar--container');
        $previousSelection.slideUp('fast');
        $('.icon--basket').removeClass('is-active');

        $searchBarContainer.slideDown('fast', function () {
            $(this)[0].scrollIntoView({behavior: 'smooth'});
            $(this).find('.search-input').focus();
        });
    },

    // take the first search form available, give it the search_for value and submit
    find: function ($label, search_for, search_type) {
        // check if the input is empty
        if (search_for === '' || search_for === undefined) {
            // check if the label is already in-error, and make it so if it is not
            if (!$label.hasClass('in-error')) {
                $label.addClass('in-error');
            }

            if (search_type === undefined) {
                search_type = 'town';
            }

            // check if the .error-message is already present, and add it if it is not
            var $search_bar__fields_container = $('.search-bar--fields-container');
            if (!$search_bar__fields_container.prev().hasClass('error-message')) {
                $search_bar__fields_container.before('<div class="error-message">Vul een plaatsnaam, postcode of krantnaam in</div>');

                // make the error messages visible
                $('.error-message').slideDown('fast');
            }

            // stop the submit by returning
            return;
        }

        var $form = $label.closest('form');
        $form.find('[name="keyword"]').val(search_for);
        $form.find('[name="search_type"]').val(search_type);
        $form.submit();
    },

    clearErrorMessage: function ($label) {
        // make the error messages visible
        $('.error-message').slideUp('fast', function () {
            $label.removeClass('in-error');
            $(this).remove();
        });
    }
};

var Products = {
    ajax_product_add: '/ajax/add-paper',
    ajax_product_remove: '/ajax/delete-paper',
    ajax_requests: [],

    init: function () {
        $(document).on('click', '.search-result--newspaper', function () {
            Products.handleProductClick($(this).val(), $(this).is(':checked'));
        });
        $(document).on('click', '.has-link', function () {
            window.location = $(this).data('href');
        });

    },

    handleProductClick: function (id, checked) {
        Map.setLoading();
        General.setButtonLoading($('.fixed-footer-buttons .button-type-submit'));

        for (var i = 0; i < Products.ajax_requests.length; i += 1) {
            if (Products.ajax_requests[i].id === id) {
                if (Products.ajax_requests[i].request !== undefined) {
                    Products.ajax_requests[i].request.abort();
                }

                Products.ajax_requests.splice(i, 1);
            }
        }

        var $checkbox = $('input[type="checkbox"][value="' + id + '"]').not('.search-result--category-selected');

        var request = $.post(
            (checked) ? Products.ajax_product_add : Products.ajax_product_remove,
            {
                id: id
            }).done(
            function (data) {
                $checkbox.prop('checked', checked);

                if (checked) {
                    Map.addOverlay($checkbox.val(), $checkbox.data('shape'));
                    Products.addToSelection($checkbox);
                } else {
                    Map.removeOverlay($checkbox.val());
                    Products.removeFromSelection($checkbox.val());
                }


                Products.ajax_requests.push({'id': id, 'request': request});
                Map.unsetLoading();
                General.unsetButtonLoading($('.fixed-footer-buttons .button-type-submit'));
            },
            'json'
        ).fail(function (response, status, error) {
            $checkbox.prop('checked', false);
            Map.unsetLoading();
            General.unsetButtonLoading($('.fixed-footer-buttons .button-type-submit'));
            alert(JSON.parse(response.responseText).result);
        });
    },

    addToSelection: function ($checkbox) {
        if (!$checkbox.hasClass('search-result--category-selected')) {
            var $li = $checkbox.parent();
            var $selectedContainer = $('.search-results--type-selected');

            $selectedContainer.slideDown('fast');

            $li
                .clone()
                .hide()
                .appendTo('.search-results--type-selected ul')
                .fadeIn('fast')
                .find('input[type="checkbox"][value="' + $checkbox.val() + '"]')
                .attr('id', 'newspaper_selected_' + $checkbox.val())
                .attr('class', 'search-result--newspaper search-result--category-selected');

            Products.updateTotalSelection();
        }
    },

    removeFromSelection: function (id) {
        var $selectedContainer = $('.search-results--type-selected');
        var $elementToRemove = $selectedContainer.find('input[type="checkbox"][value="' + id + '"]').parent();

        if ($selectedContainer.find('li').length === 1) {
            if ($selectedContainer.hasClass('search-results--type-previous-selection')) {
                Search.handleResetSwitch();
            } else {
                $selectedContainer.fadeOut('fast');
            }
        }

        $elementToRemove.fadeOut('fast', function () {
            $(this).remove();

            // make sure the container is hidden even when the user deletes newspapers very rapidly, and animation is not done yet
            if ($selectedContainer.find('li').length === 0) {
                if ($selectedContainer.hasClass('search-results--type-previous-selection')) {
                    Search.handleResetSwitch();
                } else {
                    $selectedContainer.fadeOut('fast');
                }
            }

            Products.updateTotalSelection();
        });
    },

    updateTotalSelection: function () {
        var reach = 0;
        var hasProductSelected = false;

        // check which products are selected, and sum their reach
        $('.search-results--type-selected .search-result--newspaper').each(function () {
            if ($(this).is(':checked')) {
                reach += parseInt($(this).data('reach'));
                hasProductSelected = true;
            }
        });

        // show the reach if it is above 0
        if (reach > 0) {
            $('.selected-newspapers--reach').fadeIn('fast').find('span').text(new Intl.NumberFormat('nl-NL').format(reach));
        } else {
            $('.selected-newspapers--reach').fadeOut('fast');
        }

        // show the footer submit button if at least one product is selected
        if (hasProductSelected) {
            $('.fixed-footer-buttons').fadeIn('fast');
            $('header .icon--basket').addClass('is-active');
        } else {
            $('.fixed-footer-buttons').fadeOut('fast');
            $('header .icon--basket').removeClass('is-active');
        }
    }
};

try {
    jQuery.datepicker.regional['nl'] = {
        closeText: 'Sluiten',
        prevText: 'â†',
        nextText: 'â†’',
        currentText: 'Vandaag',
        monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni',
            'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
        monthNamesShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun',
            'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
        dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
        dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
        dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
        weekHeader: 'Wk',
        dateFormat: 'dd-mm-yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        showWeek: true,
        showWeekNumbers: true,
        yearSuffix: '',
        onSelect: function (dateText, inst) {
            if (matches = dateText.match(/^(\d+)-(\d+)-(\d+)$/)) {
                var myDate = new Date();
                var currentWeek = myDate.getWeek();
                myDate.setFullYear(matches[3], matches[2] - 1, matches[1]);
                if (myDate.getWeek() < currentWeek && !adn) {
                    Modal.customAlert('Er ging iets fout', 'Het is niet mogelijk om een advertentie in het verleden te plaatsen.');
                    jQuery('input#period_field').trigger('click');
                    jQuery('input#period_field').val(currentWeek + 1);
                } else {
                    if (jQuery.inArray(myDate.getWeek(), selectedWeekNumbers) == -1) {
                        selectedWeekNumbers.push(myDate.getWeek())
                    }
                    jQuery('input#period_field').val(selectedWeekNumbers.join(','));
                    try {
                        Search.find();
                        Paper.stopMusic();
                    } catch (error) {
                        selectedWeekNumbers = [];
                    }
                }
            }
        }
    };
} catch (error) {
}

window.replaceDatepicker = function () {
    var config = {
        minDate: new Date(),
        maxDate: '+3w',
        dateFormat: 'dd-mm-yy',
        altFormat: "yy-mm-dd",
        showOn: "both",
        buttonText: "<i class='fa fa-calendar'></i>",
        beforeShowDay: function (date) {
            var dates = $(this).data('possibleDates');
            if (!dates) {
                return [1, '', ''];
            }

            var myDate = date.getFullYear() + '-' + padLeft(date.getMonth() + 1, 2) + '-' + padLeft(date.getDate(), 2);
            if (dates.indexOf(myDate) >= 0) {
                return [1, '', 'Beschikbaar'];
            } else {
                return [0, '', 'Geen uitgave'];
            }
        },
        onSelect: function (date) {
            $.post(
                '/ajax/set-date',
                {
                    id: $(this).data('uitgaveId'),
                    date: date
                }, function () {
                },
                'json'
            );
            return false;
        }
    };
    jQuery('.datepicker:not(.hasDatepicker)').datepicker(config);
};

window.padLeft = function (nr, n, str) {
    return Array(n - String(nr).length + 1).join(str || '0') + nr;
};

Date.prototype.getWeek = function (dowOffset) {
    /*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com */
    dowOffset = typeof (dowOffset) == 'int' ? dowOffset : 0; //default dowOffset to zero
    var newYear = new Date(this.getFullYear(), 0, 1);
    var day = newYear.getDay() - dowOffset; //the day of week the year begins on
    day = (day >= 0 ? day : day + 7);
    var daynum = Math.floor((this.getTime() - newYear.getTime() - (this.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) / 86400000) + 1;
    var weeknum;
    //if the year starts before the middle of a week
    if (day < 4) {
        weeknum = Math.floor((daynum + day - 1) / 7) + 1;
        if (weeknum > 52) {
            nYear = new Date(this.getFullYear() + 1, 0, 1);
            nday = nYear.getDay() - dowOffset;
            nday = nday >= 0 ? nday : nday + 7;
            /*if the next year starts before the middle of
            the week, it is week #1 of that year*/
            weeknum = nday < 4 ? 1 : 53;
        }
    } else {
        weeknum = Math.floor((daynum + day - 1) / 7);
    }
    return weeknum;
};
